import { DivineControlEvent } from "../../DivineControlEventBase.js";
export class DCBaseWheelEvent extends DivineControlEvent {
    eventType = "wheel-up";
    inputType = "mouse";
    constructor() {
        super();
    }
}
